import { sendHttpRequest } from "lib/fetcher";

export function getTemplateList(type) {
  return sendHttpRequest({
    url: "/camera/preset_templates?type=" + type,
    method: "get",
  });
}
export function createTemplate(data) {
  return sendHttpRequest({
    url: "/camera/preset_templates",
    method: "post",
    data: { data },
  });
}
export function deleteTemplate(id) {
  return sendHttpRequest({
    url: "/camera/preset_templates/" + id,
    method: "delete",
  });
}
export function getTemplateDetail(id) {
  return sendHttpRequest({
    url: "/camera/preset_templates/" + id,
    method: "get",
  });
}
export function updateTemplate(id, data) {
  return sendHttpRequest({
    url: "/camera/preset_templates/" + id,
    method: "put",
    data: { data },
  });
}
